import React from "react";
import { ComposedChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { asNumberString } from "../../../utils/formatters";
import { useLightTheme } from "../../../hooks/useLightTheme";
import PropTypes from "prop-types";

const formatter = (value) => `${asNumberString(value)}`;
const formatterDollar = (value) => `$${value}`;
const toolTipFormatter = (value, name) => {
  if (name === "earnedRevenue") {
    return [`$${asNumberString(value)}`, "Earned Revenue"];
  } else if (name === "sales") {
    return [`$${asNumberString(value)}`, "Sales"];
  } else {
    return [`${asNumberString(value)}`, "Attendance"];
  }
};
const legendFormatter = (value, entry) => {
  const { color } = entry;
  if (value === "earnedRevenue") {
    return <span style={{ color }}>Earned Revenue</span>;
  } else if (value === "sales") {
    return <span style={{ color }}>Sales</span>;
  } else {
    return <span style={{ color }}>Attendance</span>;
  }
};

export const BiAxialLineChart = ({ chartData }) => {
  const isLight = useLightTheme();
  const tickFill = isLight ? "#717173" : "#5b606a";
  const gridStroke = isLight ? "#717173" : "#696969";

  const cleanChartsData = ({ visitsData = [], salesData }) =>
    visitsData.map((item, index) => ({
      name: item.name,
      visits: item.revenue,
      sales: salesData[index].trending
    }));

  return (
    <ComposedChart
      width={1360}
      height={300}
      data={cleanChartsData(chartData)}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
      <XAxis dataKey="name" tick={{ stroke: "none", fill: tickFill }} />
      <YAxis
        yAxisId="left"
        tickFormatter={formatterDollar}
        tick={{ stroke: "none", fill: tickFill }}
      />
      <YAxis
        yAxisId="right"
        tickFormatter={formatter}
        tick={{ stroke: "none", fill: tickFill }}
        orientation="right"
      />
      <Tooltip
        formatter={toolTipFormatter}
        contentStyle={
          isLight
            ? { backgroundColor: "#fff", borderColor: "#e6e7e8" }
            : { backgroundColor: "#353942", borderColor: "#484b52" }
        }
        labelStyle={{ color: isLight ? "#1F1F20" : "#ccc" }}
      />
      <Legend formatter={legendFormatter} />
      {/* <Area yAxisId='left' type='monotone' dataKey='earnedRevenue' stroke='#0099ce' fill='#0099ce' /> */}
      <Area yAxisId="right" type="monotone" dataKey="visits" stroke="#0099ce" fill="#0099ce" />
      <Area yAxisId="left" type="monotone" dataKey="sales" stroke="#42b77a" fill="#42b77a" />
    </ComposedChart>
  );
};

BiAxialLineChart.propTypes = {
  chartData: PropTypes.object
};

export default BiAxialLineChart;
